// import swal from 'sweetalert2'
// import Vue from 'vue'
// import swal from 'sweetalert2'
// // import $ from 'jquery'

/**
 * Vue.prototype.$api
 * @type {{loadExamQuestions: BaseApi.loadExamQuestions, loadExams: BaseApi.loadExams, hideIdle: BaseApi.hideIdle, loadParticipants: BaseApi.loadParticipants, archiveStats: BaseApi.archiveStats, setCredentials: BaseApi.setCredentials, checkCredentials: BaseApi.checkCredentials, loadSurveys: BaseApi.loadSurveys, removeUser: BaseApi.removeUser, resetCredentials: BaseApi.resetCredentials, loadQuestions: BaseApi.loadQuestions, loadSystemGroupList: BaseApi.loadSystemGroupList, loadExam: BaseApi.loadExam, boolValueOfExam: BaseApi.boolValueOfExam, downloadExamRankList: BaseApi.downloadExamRankList, loadHistory: BaseApi.loadHistory, calculateExam: BaseApi.calculateExam, downloadExamPointList: BaseApi.downloadExamPointList, loadTests: BaseApi.loadTests, saveSystemGroupRights: BaseApi.saveSystemGroupRights, loadQuestion: BaseApi.loadQuestion, loadParticipantsWithAnswers: BaseApi.loadParticipantsWithAnswers, onGetError: BaseApi.onGetError, loadStats: BaseApi.loadStats, showIdle: BaseApi.showIdle, loadGroup: BaseApi.loadGroup, downloadExamGroupList: BaseApi.downloadExamGroupList, downloadExamNotesAsExcel: BaseApi.downloadExamNotesAsExcel, loadSystemGroupRights: BaseApi.loadSystemGroupRights}}
 */
const BaseApi = {
  vStruct: {
    lx: 410,
    ly: 248,
    xAbs: 116,
    yAbs: 71
  },
  saveState (fieldName, data) {
    data = JSON.stringify(data)
    if (localStorage) {
      localStorage.setItem(fieldName, data)
    }
    // console.log('saveState', fieldName, data)
  },
  getState (fieldName, defValue) {
    var data = defValue
    if (localStorage) {
      data = localStorage.getItem(fieldName)
      if (!data) {
        data = defValue
      } else {
        data = JSON.parse(data)
      }
    }
    // console.log('getState', fieldName, data)
    return data
  },
  clearState (fieldName) {
    if (localStorage) {
      localStorage.removeItem(fieldName)
    }
    console.log('clearState', fieldName)
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/storage.js